import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "container",
  style: {"margin-top":"80px","padding-top":"40px"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-6" }
const _hoisted_4 = { class: "text-dark" }
const _hoisted_5 = { style: {"font-size":"2em","font-weight":"300","color":"#33475b","margin":"0"} }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "col-lg-6 text-right mt-auto" }
const _hoisted_8 = { class: "container" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  class: "navbar navbar-light navbar-expand-md bg-light",
  role: "navigation"
}
const _hoisted_12 = { class: "form-inline mr-2" }
const _hoisted_13 = { class: "btn-group" }
const _hoisted_14 = { class: "dropdown-menu" }
const _hoisted_15 = { class: "form-inline mr-auto" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { class: "form-inline my-2 my-lg-0 mr-2" }
const _hoisted_18 = { class: "dropdown" }
const _hoisted_19 = {
  class: "text-primary font-weight-bold dropdown-toggle",
  "data-toggle": "dropdown"
}
const _hoisted_20 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = {
  class: "form-inline my-2 my-lg-0",
  role: "search"
}
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col" }
const _hoisted_25 = { class: "table table-hover" }
const _hoisted_26 = {
  style: {"width":"32px"},
  class: "align-middle"
}
const _hoisted_27 = ["onUpdate:modelValue"]
const _hoisted_28 = { class: "fg-color-gray mb-0 mt-1" }
const _hoisted_29 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_30 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_31 = {
  style: {"width":"150px"},
  class: "align-middle"
}
const _hoisted_32 = {
  key: 0,
  class: "dropdown"
}
const _hoisted_33 = {
  class: "text-primary",
  "data-toggle": "dropdown"
}
const _hoisted_34 = {
  class: "dropdown-menu",
  role: "menu"
}
const _hoisted_35 = ["onClick"]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = ["onClick"]
const _hoisted_38 = ["onClick"]
const _hoisted_39 = ["onClick"]
const _hoisted_40 = ["onClick"]
const _hoisted_41 = ["onClick"]
const _hoisted_42 = ["onClick"]
const _hoisted_43 = ["onClick"]
const _hoisted_44 = ["onClick"]
const _hoisted_45 = ["onClick"]
const _hoisted_46 = ["onClick"]
const _hoisted_47 = ["onClick"]
const _hoisted_48 = {
  class: "align-middle",
  style: {"width":"120px"}
}
const _hoisted_49 = {
  class: "progress",
  style: {"margin":"0"}
}
const _hoisted_50 = ["title"]
const _hoisted_51 = {
  style: {"width":"30px"},
  class: "align-middle"
}
const _hoisted_52 = {
  class: "align-middle",
  style: {"width":"120px"}
}
const _hoisted_53 = { class: "dropdown" }
const _hoisted_54 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_55 = {
  class: "dropdown-item",
  target: "_blank"
}
const _hoisted_56 = ["onClick"]
const _hoisted_57 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ScoringSurveyAccessLinks = _resolveComponent("ScoringSurveyAccessLinks")!
  const _component_ScoringSurveyEmailSender = _resolveComponent("ScoringSurveyEmailSender")!
  const _component_ScoringPanelistsManager = _resolveComponent("ScoringPanelistsManager")!
  const _component_PanelistConsistencyAnalysisDialog = _resolveComponent("PanelistConsistencyAnalysisDialog")!
  const _component_PortfolioOrDecisionNavigation = _resolveComponent("PortfolioOrDecisionNavigation")!
  const _component_ConsistencyAnalysisCircles = _resolveComponent("ConsistencyAnalysisCircles")!
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_ScoringSurveyAccessLinks, {
      viewModel: _ctx.scoringSurveyAccessLinks,
      onShowEmailSender: _ctx.handleShowEmailSender,
      onDownloadLinks: _ctx.handleDownloadAccessLinks
    }, null, 8 /* PROPS */, ["viewModel", "onShowEmailSender", "onDownloadLinks"]),
    _createVNode(_component_ScoringSurveyEmailSender, {
      viewModel: _ctx.scoringSurveyEmailSender,
      onSendEmail: _ctx.handleSendEmailCommand
    }, null, 8 /* PROPS */, ["viewModel", "onSendEmail"]),
    (_ctx.scoringPanelistsManager)
      ? (_openBlock(), _createBlock(_component_ScoringPanelistsManager, {
          key: 0,
          viewModel: _ctx.scoringPanelistsManager,
          onIncludePanelist: _ctx.handleIncludeScoringPanelistCommand
        }, null, 8 /* PROPS */, ["viewModel", "onIncludePanelist"]))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_PanelistConsistencyAnalysisDialog, {
      propOpened: _ctx.panelistConsistencyAnalysisOpened === true,
      propRm: _ctx.panelistConsistencyAnalysis,
      onCloseDialog: _cache[0] || (_cache[0] = ($event: any) => (_ctx.panelistConsistencyAnalysisOpened = false))
    }, null, 8 /* PROPS */, ["propOpened", "propRm"]),
    _createVNode(_component_PortfolioOrDecisionNavigation, {
      workspaceId: _ctx.workspaceId,
      projectId: _ctx.projectId
    }, null, 8 /* PROPS */, ["workspaceId", "projectId"]),
    (_ctx.Initialized)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h6", null, [
                _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_4, [...(_cache[15] || (_cache[15] = [
                  _createElementVNode("i", {
                    class: "fa fa-angle-double-left",
                    "aria-hidden": "true"
                  }, null, -1 /* CACHED */),
                  _createTextVNode(" Back to scoring panels ", -1 /* CACHED */)
                ]))])), [
                  [_directive_sanitizedHref, _ctx.url_ScoringPanelsPage]
                ])
              ]),
              _createElementVNode("h1", _hoisted_5, [
                _createTextVNode(" Panelists: " + _toDisplayString(_ctx.SurveyName) + " ", 1 /* TEXT */),
                (_ctx.Progress != null)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, "(" + _toDisplayString(_ctx.Progress) + "%)", 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                role: "button",
                class: "btn btn-outline-secondary mr-1",
                style: {"padding":"0.7em 2em"},
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.DownloadLinksCommand && _ctx.DownloadLinksCommand(...args)))
              }, "Access links"),
              _createElementVNode("button", {
                role: "button",
                class: "btn btn-success",
                style: {"padding":"0.7em 2em"},
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.AddPanelistsCommand && _ctx.AddPanelistsCommand(...args)))
              }, "Add panelists")
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _cache[34] || (_cache[34] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 60px"} }, null, -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_8, [
      (!_ctx.Initialized)
        ? (_openBlock(), _createElementBlock("h3", _hoisted_9, [...(_cache[16] || (_cache[16] = [
            _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
            _createTextVNode(" Loading... ", -1 /* CACHED */)
          ]))]))
        : _createCommentVNode("v-if", true),
      (_ctx.Initialized)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("nav", _hoisted_11, [
              _createElementVNode("form", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  (_ctx.NonePanelistsSelected)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-outline-secondary btn-sm",
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.SelectAllCommand && _ctx.SelectAllCommand(...args)))
                      }, [...(_cache[17] || (_cache[17] = [
                        _createElementVNode("i", { class: "fa-regular fa-square" }, null, -1 /* CACHED */)
                      ]))]))
                    : _createCommentVNode("v-if", true),
                  (_ctx.AnyPanelistsSelected && !_ctx.AllPanelistsSelected)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "button",
                        class: "btn btn-outline-secondary btn-sm",
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.UnselectAllCommand && _ctx.UnselectAllCommand(...args)))
                      }, [...(_cache[18] || (_cache[18] = [
                        _createElementVNode("i", { class: "fa fa-square-minus" }, null, -1 /* CACHED */)
                      ]))]))
                    : _createCommentVNode("v-if", true),
                  (_ctx.AllPanelistsSelected)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        type: "button",
                        class: "btn btn-outline-secondary btn-sm",
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.UnselectAllCommand && _ctx.UnselectAllCommand(...args)))
                      }, [...(_cache[19] || (_cache[19] = [
                        _createElementVNode("i", { class: "fa-regular fa-square-check" }, null, -1 /* CACHED */)
                      ]))]))
                    : _createCommentVNode("v-if", true),
                  _cache[20] || (_cache[20] = _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-outline-secondary btn-sm dropdown-toggle dropdown-toggle-split",
                    "data-toggle": "dropdown"
                  }, null, -1 /* CACHED */)),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("a", {
                      class: "dropdown-item",
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.SelectAllCommand && _ctx.SelectAllCommand(...args)))
                    }, "All"),
                    _createElementVNode("a", {
                      class: "dropdown-item",
                      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.UnselectAllCommand && _ctx.UnselectAllCommand(...args)))
                    }, "None"),
                    _createElementVNode("a", {
                      class: "dropdown-item",
                      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.InverseSelectionCommand && _ctx.InverseSelectionCommand(...args)))
                    }, "Inverse")
                  ])
                ])
              ]),
              _createElementVNode("form", _hoisted_15, [
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["btn btn-sm", [_ctx.NonePanelistsSelected ? 'btn-outline-secondary' : 'btn-outline-primary']]),
                  disabled: _ctx.NonePanelistsSelected,
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.EmailManyCommand && _ctx.EmailManyCommand(...args)))
                }, " Send email (" + _toDisplayString(_ctx.SelectedPanelistsCount) + ") ", 11 /* TEXT, CLASS, PROPS */, _hoisted_16)
              ]),
              _createElementVNode("form", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _cache[28] || (_cache[28] = _createTextVNode(" Filter: ", -1 /* CACHED */)),
                  _createElementVNode("a", _hoisted_19, _toDisplayString(_ctx.FilterLabel), 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("a", {
                      class: "dropdown-item my-2",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.resetFilters()))
                    }, [...(_cache[21] || (_cache[21] = [
                      _createElementVNode("span", null, "All panelists", -1 /* CACHED */)
                    ]))]),
                    _cache[25] || (_cache[25] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                    _cache[26] || (_cache[26] = _createElementVNode("h6", { class: "dropdown-header" }, "By progress:", -1 /* CACHED */)),
                    _createElementVNode("a", {
                      class: "dropdown-item my-2",
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.filterByProgress('Not started')))
                    }, [...(_cache[22] || (_cache[22] = [
                      _createElementVNode("span", null, "Not started", -1 /* CACHED */)
                    ]))]),
                    _createElementVNode("a", {
                      class: "dropdown-item my-2",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.filterByProgress('In progress')))
                    }, [...(_cache[23] || (_cache[23] = [
                      _createElementVNode("span", null, "In progress", -1 /* CACHED */)
                    ]))]),
                    _createElementVNode("a", {
                      class: "dropdown-item my-2",
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.filterByProgress('Completed')))
                    }, [...(_cache[24] || (_cache[24] = [
                      _createElementVNode("span", null, "Completed", -1 /* CACHED */)
                    ]))]),
                    _cache[27] || (_cache[27] = _createElementVNode("h6", { class: "dropdown-header" }, "By tag:", -1 /* CACHED */)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tags, (t) => {
                      return (_openBlock(), _createElementBlock("a", {
                        class: "dropdown-item",
                        onClick: ($event: any) => (_ctx.filterByTag(t))
                      }, _toDisplayString(t), 9 /* TEXT, PROPS */, _hoisted_21))
                    }), 256 /* UNKEYED_FRAGMENT */))
                  ])
                ])
              ]),
              _createElementVNode("form", _hoisted_22, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-control form-control-sm mr-sm-2",
                  type: "search",
                  placeholder: "Search",
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.SearchPhrase) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.SearchPhrase]
                ])
              ])
            ]),
            _cache[33] || (_cache[33] = _createElementVNode("br", null, null, -1 /* CACHED */)),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("table", _hoisted_25, [
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.PanelistsView, (p) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: p.Id
                      }, [
                        _createElementVNode("td", _hoisted_26, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": ($event: any) => ((p.Selected) = $event),
                            style: {"width":"16px","height":"16px"}
                          }, null, 8 /* PROPS */, _hoisted_27), [
                            [_vModelCheckbox, p.Selected]
                          ])
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("p", _hoisted_28, [
                            _createElementVNode("span", null, _toDisplayString(p.Name), 1 /* TEXT */)
                          ]),
                          (p.HasEmail)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_29, _toDisplayString(p.Email), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true),
                          (!p.HasEmail)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_30, "Email not provided"))
                            : _createCommentVNode("v-if", true)
                        ]),
                        _createElementVNode("td", _hoisted_31, [
                          (!p.IsDeleted)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                _createElementVNode("a", _hoisted_33, "Vote strength: " + _toDisplayString(p.VoteStrength), 1 /* TEXT */),
                                _createElementVNode("div", _hoisted_34, [
                                  _createElementVNode("a", {
                                    class: "dropdown-item",
                                    onClick: ($event: any) => {_ctx.handleChangeCriteriaPanelistVoteStrengthCommand(p, 0);}
                                  }, "Vote strength: 0", 8 /* PROPS */, _hoisted_35),
                                  _createElementVNode("a", {
                                    class: "dropdown-item",
                                    onClick: ($event: any) => {_ctx.handleChangeCriteriaPanelistVoteStrengthCommand(p, 1);}
                                  }, "Vote strength: 1", 8 /* PROPS */, _hoisted_36),
                                  _createElementVNode("a", {
                                    class: "dropdown-item",
                                    onClick: ($event: any) => {_ctx.handleChangeCriteriaPanelistVoteStrengthCommand(p, 2);}
                                  }, "Vote strength: 2", 8 /* PROPS */, _hoisted_37),
                                  _createElementVNode("a", {
                                    class: "dropdown-item",
                                    onClick: ($event: any) => {_ctx.handleChangeCriteriaPanelistVoteStrengthCommand(p, 3);}
                                  }, "Vote strength: 3", 8 /* PROPS */, _hoisted_38),
                                  _createElementVNode("a", {
                                    class: "dropdown-item",
                                    onClick: ($event: any) => {_ctx.handleChangeCriteriaPanelistVoteStrengthCommand(p, 4);}
                                  }, "Vote strength: 4", 8 /* PROPS */, _hoisted_39),
                                  _createElementVNode("a", {
                                    class: "dropdown-item",
                                    onClick: ($event: any) => {_ctx.handleChangeCriteriaPanelistVoteStrengthCommand(p, 5);}
                                  }, "Vote strength: 5", 8 /* PROPS */, _hoisted_40),
                                  _createElementVNode("a", {
                                    class: "dropdown-item",
                                    onClick: ($event: any) => {_ctx.handleChangeCriteriaPanelistVoteStrengthCommand(p, 6);}
                                  }, "Vote strength: 6", 8 /* PROPS */, _hoisted_41),
                                  _createElementVNode("a", {
                                    class: "dropdown-item",
                                    onClick: ($event: any) => {_ctx.handleChangeCriteriaPanelistVoteStrengthCommand(p, 7);}
                                  }, "Vote strength: 7", 8 /* PROPS */, _hoisted_42),
                                  _createElementVNode("a", {
                                    class: "dropdown-item",
                                    onClick: ($event: any) => {_ctx.handleChangeCriteriaPanelistVoteStrengthCommand(p, 8);}
                                  }, "Vote strength: 8", 8 /* PROPS */, _hoisted_43),
                                  _createElementVNode("a", {
                                    class: "dropdown-item",
                                    onClick: ($event: any) => {_ctx.handleChangeCriteriaPanelistVoteStrengthCommand(p, 9);}
                                  }, "Vote strength: 9", 8 /* PROPS */, _hoisted_44),
                                  _createElementVNode("a", {
                                    class: "dropdown-item",
                                    onClick: ($event: any) => {_ctx.handleChangeCriteriaPanelistVoteStrengthCommand(p, 10);}
                                  }, "Vote strength: 10", 8 /* PROPS */, _hoisted_45),
                                  _cache[29] || (_cache[29] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                                  _createElementVNode("a", {
                                    class: "dropdown-item",
                                    onClick: ($event: any) => (_ctx.handleExcludePanelistsCommand(p))
                                  }, "Exclude", 8 /* PROPS */, _hoisted_46)
                                ])
                              ]))
                            : _createCommentVNode("v-if", true),
                          (p.IsDeleted)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                class: "text-primary",
                                onClick: ($event: any) => (_ctx.handleExcludePanelistsCommand(p))
                              }, "Exclude", 8 /* PROPS */, _hoisted_47))
                            : _createCommentVNode("v-if", true)
                        ]),
                        _createElementVNode("td", _hoisted_48, [
                          _createElementVNode("div", _hoisted_49, [
                            _createElementVNode("div", {
                              style: _normalizeStyle({ 'width': `${p.Progress}%` }),
                              title: `${p.Progress}%`,
                              class: "progress-bar progress-bar-success progress-bar-striped",
                              role: "progressbar"
                            }, null, 12 /* STYLE, PROPS */, _hoisted_50)
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_51, [
                          (!p.IsDeleted)
                            ? (_openBlock(), _createBlock(_component_ConsistencyAnalysisCircles, {
                                key: 0,
                                class: "pointer",
                                status: p.ConsistencyAnalysisStatus,
                                size: 1,
                                onShowConsistencyAnalysis: ($event: any) => (_ctx.showPanelistConsistencyAnalysis(p.Id))
                              }, null, 8 /* PROPS */, ["status", "onShowConsistencyAnalysis"]))
                            : _createCommentVNode("v-if", true)
                        ]),
                        _createElementVNode("td", _hoisted_52, [
                          _createElementVNode("div", _hoisted_53, [
                            _cache[32] || (_cache[32] = _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-outline-secondary dropdown-toggle",
                              "data-toggle": "dropdown"
                            }, " Actions ", -1 /* CACHED */)),
                            _createElementVNode("div", _hoisted_54, [
                              _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_55, [...(_cache[30] || (_cache[30] = [
                                _createTextVNode("Review", -1 /* CACHED */)
                              ]))])), [
                                [_directive_sanitizedHref, `/#/scoring/dashboard/${_ctx.workspaceId}/${_ctx.surveyId}/${p.Id}`]
                              ]),
                              _createElementVNode("a", {
                                class: "dropdown-item",
                                onClick: ($event: any) => (_ctx.EmailOneCommand(p))
                              }, "Email", 8 /* PROPS */, _hoisted_56),
                              _cache[31] || (_cache[31] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                              _createElementVNode("a", {
                                class: "dropdown-item",
                                onClick: ($event: any) => (_ctx.handleExcludePanelistsCommand(p))
                              }, "Exclude", 8 /* PROPS */, _hoisted_57)
                            ])
                          ])
                        ])
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}